/* eslint-disable react/jsx-key */
import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { List, message, Switch } from 'antd-v5';
import { useQuery } from 'react-query';
import { SettingsContent } from '../../../components/SettingsContent';
import { enableAppointment, getStoresAppointmentEnabled } from '../../../../../../services/appointments';

export const EnableAppointment = props => {

  const {
    data: allStores,
    isFetching,
    refetch,
  } = useQuery(
    ['allStores', props.merchantId, props.userId],
    async () => {
      return getStoresAppointmentEnabled();
    },
    {
      refetchOnWindowFocus: false,
      initialData: [],
    },
  );

  return (
    <div style={{ paddingTop: '25px' }}>
      <SettingsContent
        title="Stores Accepting Appointments"
        description="Enable and disable appointments for respective stores"
      >
        <List
          className="w-100-P"
          size="small"
          dataSource={allStores}
          renderItem={item => <EnableAppointmentItem item={item} refetch={refetch} />}
          loading={isFetching}
        />
      </SettingsContent>
    </div>
  );
};

const EnableAppointmentItem = ({ item, refetch }) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [appointmentsEnabled, setAppointmentsEnabled] = useState(item?.appointments_enabled);

  const handleSuccess = useCallback(
    async data => {
      try {
        setConfirmLoading(true);
        setAppointmentsEnabled(data);
        await enableAppointment(item.id, data);
        message.success('Appointment enabled successfully');
      } catch (error) {
        message.error('Error updating appointment type');
      } finally {
        refetch();
        setConfirmLoading(false);
      }
    },
    [item.id],
  );

  return (
    <List.Item
      styles={{ actions: { margin: 0 } }}
      actions={[
        <Switch value={appointmentsEnabled} onChange={value => handleSuccess(value)} loading={confirmLoading} />,
      ]}
      key={item.id}
    >
      {item.name}
    </List.Item>
  );
};

const mapStateToProps = state => {
  return {
    auth: state.auth,
    stores: state.stores,
    merchantId: state.auth.merchantId,
    userId: state.auth.userId,
  };
};
export default connect(mapStateToProps, {})(EnableAppointment);
